<template>
  <div class="achievements-info-modal m-bx3">
    <div class="f f-h f-ac f-sb m-bx3">
      <div class="t-xl bold m-tx3">Donut badges</div>
      <donut-modal-sections-actions
        :show-cancel="true"
        cancel-text="Close"
        :button-text="null"
      />
    </div>
    <div class="t-lg dark-gray m-bx2">
      You can earn Donut badges by supporting your company culture doing the actions below.
    </div>
    <div v-if="allBadges.length > 0" class="f f-h f-gap-16">
      <div class="f f-v fc-f2 f-as">
        <div class="t-sm bold">Badge</div>
        <div v-for="badge in sortedBadges" :key="badge.machine_name" class="f f-h f-gap-4 f-as h-20 m-tx2">
          <div v-emoji="badge.emoji" class="t-sm" />
          <span class="t-sm demibold">{{ badge.name }}</span>
        </div>
      </div>
      <div class="f f-v fc-g1 f-as">
        <div class="t-sm bold">Actions</div>
        <div v-for="badge in sortedBadges" :key="badge.machine_name" class="t-sm h-20 m-tx2">
          {{ badge.description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const { state } = useStore();

const allBadges = computed(() => {
  const badges = state.modal.data?.badges || [];
  return badges;
});

const sortedBadges = computed(() => [...allBadges.value].sort((a, b) => {
    // Sort by product first, then by name
    if (a.product !== b.product) {
      return a.product - b.product;
    }
    return a.name.localeCompare(b.name);
  }));
</script>

